import React from 'react'
import { Image } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { useModal } from '@zet/common/hooks/useModal'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { BTN_SM, Icon, SH3, Stack, XStack, colors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'
import { nativeShare } from '@zet/utils/shareLink'

import {
  VKYCVideoId,
  VKYCVideoLink,
  VKYCVideoThumbail,
} from '../utils/constants'

type ShareVKYCPendingReminderProps = {
  isWarningIntent?: boolean
  customerName?: string
  customerPhoneNumber?: number | string
  videoData?: {
    en: {
      thumbnail: string
      url: string
      video_id: string
    }
    hi: {
      thumbnail: string
      url: string
      video_id: string
    }
  }
  leadId?: number
  partnerId?: number
}

type WhatsappType = 'WHATSAPP' | 'WHATSAPP_FOR_BUSINESS' | undefined
let whatsappType: WhatsappType

export const ShareVKYCPendingReminder = ({
  customerName,
  customerPhoneNumber,
  videoData,
  isWarningIntent = false,
  leadId,
  partnerId,
}: ShareVKYCPendingReminderProps) => {
  const { openModal } = useModal()
  const shareMessage = i18n.t('leads.shareMessage', {
    customerName: customerName,
    videoUrl: `${
      videoData?.[i18n.locale as keyof typeof videoData]?.url || VKYCVideoLink
    }`,
  })
  const navigation = useNavigation()

  const onSharePress = async () => {
    publishEvent('click_action', {
      item_name: 'vkyc-video_share',
      feature: 'vkyc_education',
      lead_ID: leadId || '',
      partner_ID: partnerId || '',
    })
    const shareConfig = {
      base64Image: '',
      message: shareMessage,
    }
    nativeShare(shareConfig)
  }

  const onVideoPress = () => {
    publishEvent('click_action', {
      item_name: 'vkyc-video_play',
      feature: 'vkyc_education',
      lead_ID: leadId || '',
      partner_ID: partnerId || '',
    })
    navigation.navigate('TraingVideoPlayer', {
      videoId:
        videoData?.[i18n.locale as keyof typeof videoData]?.video_id ||
        VKYCVideoId,
      youtube_video_details: {
        en: { videoId: videoData?.en?.video_id ?? '' },
        hi: { videoId: videoData?.hi?.video_id ?? '' },
      },
      isGenericVideoPlayer: true,
    })
  }

  return (
    <Stack
      className={`flex-1 rounded px-3 ${
        isWarningIntent ? 'bg-warning-10' : 'bg-secondary-10'
      } mt-2 border-t pb-3 pt-2 ${
        isWarningIntent ? 'border-[#FADFC6]' : 'border-primary-20'
      }`}
    >
      <XStack className="items-center justify-between">
        <SH3>{i18n.t('leads.howToDoVKYC')}</SH3>
        <Pressable
          className="flex-row items-center justify-center gap-1"
          onPress={onSharePress}
        >
          <BTN_SM className="text-primary-100">
            {i18n.t('leads.shareWithCustomer')}
          </BTN_SM>
          <Icon type="Share" color={colors.primary[100]} size={20} />
        </Pressable>
      </XStack>
      <Pressable className="h-[150] w-full pt-2" onPress={onVideoPress}>
        <Image
          className="h-full w-full rounded-lg"
          source={{
            uri:
              videoData?.[i18n.locale as keyof typeof videoData]?.thumbnail ??
              VKYCVideoThumbail,
          }}
          resizeMode="contain"
        />
      </Pressable>
    </Stack>
  )
}
